import { Box, Card, CardActionArea, Chip, Stack, Typography } from '@mui/material';
import type { Ticket } from '../api';

export function BoardView({
  tickets,
  statuses,
  onOpen,
}: {
  tickets: Ticket[];
  statuses: string[];
  onOpen: (ref: number) => void;
}) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: `repeat(${statuses.length}, minmax(240px, 1fr))` },
        gap: 2,
        p: 2,
        alignItems: 'start',
      }}
    >
      {statuses.map((status) => {
        const column = tickets.filter((ticket) => ticket.status === status && !ticket.archived);
        return (
          <Stack key={status} spacing={1}>
            <Stack direction="row" spacing={1} alignItems="baseline">
              <Typography variant="subtitle2" fontWeight={600}>
                {status}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {column.length}
              </Typography>
            </Stack>

            {column.map((ticket) => (
              <Card key={ticket.ref} variant="outlined">
                <CardActionArea onClick={() => onOpen(ticket.ref)} sx={{ p: 1.25 }}>
                  <Typography
                    variant="caption"
                    color="primary"
                    sx={{ fontVariantNumeric: 'tabular-nums' }}
                  >
                    DWLF-{ticket.ref}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 1, lineHeight: 1.35 }}>
                    {ticket.name}
                  </Typography>
                  <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
                    <Chip size="small" variant="outlined" label={ticket.epic} />
                    {ticket.effort !== 'Unknown' && (
                      <Chip size="small" variant="outlined" label={ticket.effort} />
                    )}
                  </Stack>
                </CardActionArea>
              </Card>
            ))}
          </Stack>
        );
      })}
    </Box>
  );
}
